import { combineReducers } from 'redux';
import {
  SET_ROW_PADDING,
  SET_ROW_MARGIN,
} from '../actions/action-names';

const padding = (state = '', action) => {
  switch (action.type) {
    case SET_ROW_PADDING:
      return action.value;
    default:
      return state;
  }
};

const margin = (state = '', action) => {
  switch (action.type) {
    case SET_ROW_MARGIN:
      return action.value;
    default:
      return state;
  }
};

export default combineReducers({
  padding,
  margin
});



// WEBPACK FOOTER //
// ./app/header-builder/reducers/row-options-reducers.js